import {useState} from 'react';
import FaqSubItem from './FaqSubItem';
import * as Styled from './FaqItemStyles';
import Headline from '../Headline/Headline';

interface FaqItemStandardProps {
  icon: Module;
  header: string;
  subItems: Array<any>;
}

interface Module{
  default: string;
}

const FaqItem = ({icon, header, subItems}:FaqItemStandardProps) => {
  const [isBoxVisible, setIsBoxVisible] = useState(false);
  
  return (
    <Styled.Container>
      <Styled.Container className={`FaqItem ${isBoxVisible ? 'RotateExpand' : '' }`} onClick={()=>setIsBoxVisible(currValue => !currValue)}>
        <img src={icon.default} alt="Faq item icon"/>
        <Headline tag="h2" className="ItemTitle" >{header}</Headline>
      </Styled.Container>
      <Styled.Container>
        {
          isBoxVisible ?
          subItems.map( (e:any, i:number) => (
            <FaqSubItem
              header={e.header}
              text={e.text}
              key={i}
            />
          ))
          :
          null
        }
      </Styled.Container>
    </Styled.Container>
  );
}

export default FaqItem;